import Script from 'next/script';
import { useEffect, useState } from 'react';
import { sierraAgentToken, sierraConfig } from 'shared/utils/sierra/sierra';

const SierraScript = () => {
  const [isConfigSet, setIsConfigSet] = useState(false);

  useEffect(() => {
    if (isConfigSet) return;

    if (typeof window !== 'undefined') {
      window.sierraConfig = sierraConfig;
      setIsConfigSet(true);
    }
  }, [isConfigSet]);

  if (!isConfigSet) return null;

  return (
    <Script
      type="module"
      strategy="lazyOnload"
      src={`https://sierra.chat/agent/${sierraAgentToken}/embed`}
    />
  );
};

export default SierraScript;
